const investmentPageLang = {
	dashboard_title: {
		tag: 'investment.page.dashboard_title',
		fr: 'Tableau de bord',
		en: 'Dashboard',
	},
};

export default investmentPageLang;
